// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"56380bd7","344":"23b01781","504":"8c4801e6","824":"23b01781"}[chunkId] + ".chunk.css";
};